 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"article-list":"article-list","article-detail":"article-detail","exercise~exercise-question~exercise-question-detail~exercise-question-list~exercise-target~question-~07e03d77":"exercise~exercise-question~exercise-question-detail~exercise-question-list~exercise-target~question-~07e03d77","exercise":"exercise","expert":"expert","exercise-question-detail":"exercise-question-detail","exercise-question":"exercise-question","exercise-question-list":"exercise-question-list","exercise-target":"exercise-target","question-lecturer-list":"question-lecturer-list"}[chunkId]||chunkId) + "." + {"article-list":"15752768","chunk-171bb67c":"39ba474e","chunk-ade1586e":"110a43ed","chunk-2d0b1e82":"b3cd96e6","article-detail":"687bad82","chunk-05c3df1a":"3eba27a1","chunk-0f8aa536":"2b11b900","chunk-25fb33cd":"154976ac","chunk-29b1cfb5":"c98c9149","chunk-2c3c5de0":"1f207fa8","chunk-78f7fa0e":"950f95e4","chunk-e253347a":"31711736","chunk-45514f7c":"8d1f7e5a","chunk-2f5a0744":"c9820612","chunk-377f88b5":"5bb7e8cf","chunk-3d6e642a":"6e1b0233","chunk-4b9d412b":"e8af9730","chunk-b693cf40":"afc8e1a3","chunk-5ee4dabb":"dd9bc78b","chunk-638b64b1":"8e2a97d1","chunk-643f11d8":"7f638865","chunk-662b2f22":"0149bdbf","chunk-13882650":"3e895527","chunk-682ef38e":"f4a37731","chunk-6b1040ea":"9783706d","chunk-77c96ebc":"bc0e287d","chunk-7a5505fe":"4a456aec","chunk-4c240318":"da5a8f3b","chunk-7c02fc9a":"8bbfbd7c","chunk-8d922fae":"c8475c69","chunk-2b38207c":"67e5b20c","chunk-34dbc6bd":"4b97eade","chunk-39aab335":"6fb303e7","chunk-3e295398":"da0b7085","chunk-40b72a5a":"11d114b4","chunk-572f21c8":"df7c2f4b","chunk-75b79983":"733b7663","chunk-20300471":"5b03438d","chunk-5435d5b6":"a4cc6139","chunk-b4c1edf4":"03cb88f5","exercise~exercise-question~exercise-question-detail~exercise-question-list~exercise-target~question-~07e03d77":"f586afdd","exercise":"e25b9e37","chunk-6dd840fb":"4eb30b7d","chunk-691fa803":"1733adfd","chunk-988e76d4":"12a7ddb4","chunk-9faf310e":"5a643127","chunk-dbae8fb6":"2868cc79","expert":"b72b8e33","chunk-b93f00b0":"430bce58","chunk-3a521625":"b1f7d30c","chunk-626b7abe":"c92c8f7e","chunk-7bede95c":"f31bc354","chunk-c747c49a":"6e73aadb","chunk-e86d778c":"ae180c06","chunk-2d2250de":"18ccfca0","chunk-34d91302":"f9b11d77","chunk-3f528f34":"19a7ff42","chunk-40d38d46":"47fe8d42","chunk-ff9fbdd4":"3ffca4e2","chunk-4d3add88":"6c75ae28","chunk-297a0168":"b5749241","chunk-4c2bf481":"e339bb23","chunk-348c3cff":"f19fbc06","chunk-1d764d80":"751c8bd3","chunk-573f7ff2":"5fd45513","chunk-702521ea":"8ec01e3d","chunk-02e1d886":"7d1924f1","chunk-3e9fcef2":"4cbf9ddd","chunk-8d108984":"09c7ef58","chunk-b44f26d8":"7ebb47dc","chunk-b4ffd7ec":"2535bbf7","chunk-ff06a4fc":"26aa4ffe","exercise-question-detail":"33bc8dce","exercise-question":"dfe59830","exercise-question-list":"d64ab587","exercise-target":"43763cc9","question-lecturer-list":"1038acf2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"article-list":1,"chunk-171bb67c":1,"chunk-ade1586e":1,"article-detail":1,"chunk-05c3df1a":1,"chunk-0f8aa536":1,"chunk-25fb33cd":1,"chunk-29b1cfb5":1,"chunk-78f7fa0e":1,"chunk-e253347a":1,"chunk-45514f7c":1,"chunk-2f5a0744":1,"chunk-377f88b5":1,"chunk-3d6e642a":1,"chunk-4b9d412b":1,"chunk-b693cf40":1,"chunk-5ee4dabb":1,"chunk-638b64b1":1,"chunk-643f11d8":1,"chunk-662b2f22":1,"chunk-13882650":1,"chunk-682ef38e":1,"chunk-6b1040ea":1,"chunk-77c96ebc":1,"chunk-4c240318":1,"chunk-7c02fc9a":1,"chunk-8d922fae":1,"chunk-2b38207c":1,"chunk-34dbc6bd":1,"chunk-39aab335":1,"chunk-3e295398":1,"chunk-40b72a5a":1,"chunk-75b79983":1,"chunk-20300471":1,"chunk-5435d5b6":1,"chunk-b4c1edf4":1,"exercise~exercise-question~exercise-question-detail~exercise-question-list~exercise-target~question-~07e03d77":1,"exercise":1,"chunk-6dd840fb":1,"chunk-691fa803":1,"chunk-988e76d4":1,"chunk-9faf310e":1,"chunk-dbae8fb6":1,"expert":1,"chunk-b93f00b0":1,"chunk-3a521625":1,"chunk-626b7abe":1,"chunk-7bede95c":1,"chunk-c747c49a":1,"chunk-e86d778c":1,"chunk-34d91302":1,"chunk-3f528f34":1,"chunk-40d38d46":1,"chunk-ff9fbdd4":1,"chunk-4d3add88":1,"chunk-297a0168":1,"chunk-4c2bf481":1,"chunk-348c3cff":1,"chunk-1d764d80":1,"chunk-573f7ff2":1,"chunk-702521ea":1,"chunk-02e1d886":1,"chunk-3e9fcef2":1,"chunk-8d108984":1,"chunk-b44f26d8":1,"chunk-b4ffd7ec":1,"chunk-ff06a4fc":1,"exercise-question-detail":1,"exercise-question":1,"exercise-question-list":1,"exercise-target":1,"question-lecturer-list":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"article-list":"article-list","article-detail":"article-detail","exercise~exercise-question~exercise-question-detail~exercise-question-list~exercise-target~question-~07e03d77":"exercise~exercise-question~exercise-question-detail~exercise-question-list~exercise-target~question-~07e03d77","exercise":"exercise","expert":"expert","exercise-question-detail":"exercise-question-detail","exercise-question":"exercise-question","exercise-question-list":"exercise-question-list","exercise-target":"exercise-target","question-lecturer-list":"question-lecturer-list"}[chunkId]||chunkId) + "." + {"article-list":"1fa4abe0","chunk-171bb67c":"b850a7b5","chunk-ade1586e":"99c8ede3","chunk-2d0b1e82":"31d6cfe0","article-detail":"b1f5d1f8","chunk-05c3df1a":"cba90f3a","chunk-0f8aa536":"7878041d","chunk-25fb33cd":"aa0141cc","chunk-29b1cfb5":"8f40c93d","chunk-2c3c5de0":"31d6cfe0","chunk-78f7fa0e":"c8b19902","chunk-e253347a":"e9071c8a","chunk-45514f7c":"4b226784","chunk-2f5a0744":"6f3a49e9","chunk-377f88b5":"c4410978","chunk-3d6e642a":"ec5174ae","chunk-4b9d412b":"8820feff","chunk-b693cf40":"24f68572","chunk-5ee4dabb":"f45aedb6","chunk-638b64b1":"06ad684f","chunk-643f11d8":"24894234","chunk-662b2f22":"b834244e","chunk-13882650":"c4091eed","chunk-682ef38e":"aa89c22a","chunk-6b1040ea":"17382bb7","chunk-77c96ebc":"a5b44cdc","chunk-7a5505fe":"31d6cfe0","chunk-4c240318":"2baf4da8","chunk-7c02fc9a":"904d6a27","chunk-8d922fae":"48f4b6ec","chunk-2b38207c":"1c248de5","chunk-34dbc6bd":"5bcd3972","chunk-39aab335":"571a42eb","chunk-3e295398":"a78f11e3","chunk-40b72a5a":"fa7b71c1","chunk-572f21c8":"31d6cfe0","chunk-75b79983":"6bfcb1e4","chunk-20300471":"9da65d6c","chunk-5435d5b6":"9da65d6c","chunk-b4c1edf4":"68e9a6c4","exercise~exercise-question~exercise-question-detail~exercise-question-list~exercise-target~question-~07e03d77":"69fa1499","exercise":"e64564eb","chunk-6dd840fb":"188a9abb","chunk-691fa803":"c01cf221","chunk-988e76d4":"4ed2f48f","chunk-9faf310e":"6539539b","chunk-dbae8fb6":"d06a175b","expert":"22d133a3","chunk-b93f00b0":"f55a0079","chunk-3a521625":"3bd9028a","chunk-626b7abe":"daa48ec6","chunk-7bede95c":"7200eefb","chunk-c747c49a":"28994338","chunk-e86d778c":"0af58f05","chunk-2d2250de":"31d6cfe0","chunk-34d91302":"8a24bfa9","chunk-3f528f34":"5384a74e","chunk-40d38d46":"2e6d7d1f","chunk-ff9fbdd4":"44fec867","chunk-4d3add88":"2f2f4d08","chunk-297a0168":"9d90bfc6","chunk-4c2bf481":"3dc08c0c","chunk-348c3cff":"653dcd69","chunk-1d764d80":"a216cdf1","chunk-573f7ff2":"d9f6dd01","chunk-702521ea":"c63f5ed7","chunk-02e1d886":"a58a0f21","chunk-3e9fcef2":"9c6c45de","chunk-8d108984":"6399a585","chunk-b44f26d8":"ce964d23","chunk-b4ffd7ec":"aec0bb9b","chunk-ff06a4fc":"98b52b23","exercise-question-detail":"a8555993","exercise-question":"8ba75520","exercise-question-list":"2503d4b3","exercise-target":"ec054106","question-lecturer-list":"6a828fcc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/learn/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
